module.exports = __webpack_public_path__ + "static/media/features-split-image-01.aba60ca4.jpg";